'use client'
import { useEffect } from 'react'
import { LOCALE_COOKIE, normalizeLocale } from '@/lib/i18n'

// 修正 <html lang>：layout 保持静态，客户端按语言 Cookie 设置（不渲染内容，无 hydration 问题）
export default function HtmlLang() {
    useEffect(() => {
        const m = document.cookie.match(new RegExp(`(?:^|; )${LOCALE_COOKIE}=([^;]*)`))
        document.documentElement.lang = normalizeLocale(decodeURIComponent(m?.[1] ?? '')) === 'en' ? 'en' : 'zh-CN'
    }, [])
    return null
}
